import script from "./AiReady.vue?vue&type=script&setup=true&lang=js"
export * from "./AiReady.vue?vue&type=script&setup=true&lang=js"

import "./AiReady.vue?vue&type=style&index=0&id=671b685d&lang=scss&scoped=true"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-671b685d"]])

export default __exports__